import PropTypes from 'prop-types'
import { formatUtcToLocal } from '../../utils/format'

const ScheduledMatchModal = ({
  isOpen,
  selectedMatch,
  selectedMatchOpponent,
  closeMatchModal,
  leagueId,
  navigate,
}) => {
  if (!isOpen || !selectedMatch) return null

  const isCompleted =
    selectedMatch?.status && selectedMatch.status !== 'scheduled'

  return (
    <div className="modal-overlay" onClick={closeMatchModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h4>{isCompleted ? 'Match Details' : 'Scheduled Match'}</h4>
          <button className="close-btn" onClick={closeMatchModal}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="match-details">
            <p>
              <strong>Opponent:</strong>{' '}
              {selectedMatchOpponent
                ? `${selectedMatchOpponent.first_name} ${selectedMatchOpponent.last_name}`
                : 'Unknown'}
            </p>
            <p>
              <strong>Date & Time:</strong>{' '}
              {formatUtcToLocal(
                selectedMatch.match_datetime,
                "EEEE, MMM d, yyyy 'at' h:mm a",
              )}
            </p>
            {selectedMatch.location && (
              <p>
                <strong>Location:</strong> {selectedMatch.location}
              </p>
            )}
          </div>
          <div className="match-actions mt-3">
            <button
              className="btn btn-primary"
              onClick={() => {
                navigate(`/leagues/${leagueId}/match/${selectedMatch.id}/score`)
                closeMatchModal()
              }}
            >
              {isCompleted ? 'View Match' : 'Enter Match Score'}
            </button>
            <button
              className="btn btn-secondary ms-2"
              onClick={closeMatchModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

ScheduledMatchModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  selectedMatch: PropTypes.object,
  selectedMatchOpponent: PropTypes.object,
  closeMatchModal: PropTypes.func.isRequired,
  leagueId: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
}

export default ScheduledMatchModal
